import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';


let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}
 
let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    },
  },
  {
    label: "Expense Category",
    field: "expense_category",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Expense Category",
    },
  },
  {
    label: "Category Type",
    field: "category_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Category Type",
    },
  },
  {
    label: "Amount",
    field: "amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Amount",
    },
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,

      paidAmount: 0,
      unpaidAmount: 0,
      total: 0,

      startDate: moment(_startDateYaer).format("YYYY-MM-DD"),
      endDate: moment(_endDateYaer).format("YYYY-MM-DD"),
      dateLabel: "",
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey);
  }

  getSaleListData(_type) {
    let _transArray = [];

    const requestData = JSON.stringify({
        business_id: this.state.businessId,
        company_id: this.state.company_id,
        type: _type,
        isDateFilter: true,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
    });

    PostData(global.expenseCategoryReport, requestData, "POST")
        .then((result) => {
            let responseJson = result;
            if (!responseJson.success) {
                this.setState({
                    transactionArrayFilter: [],
                    itemArray: [],
                    isLoaded: true,
                    countList: 0
                });
            } else {
                if (responseJson.response) {
                    _transArray = responseJson.response.map((itm, index) => ({
                        srNo: index + 1, // ✅ generate serial number here
                        expense_category: itm.expense_category,
                        expense_type: itm.expense_type,
                        total: itm.total
                    }));
                }
                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    countList: responseJson.countList
                });
            }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
  }


 
  loadTranscListing() {
    let dataList = { columns: columns, rows: [] };

    if (this.state.isLoaded) {
        let _transDetails = this.state.transactionArrayFilter;
        if (_transDetails.length > 0) {
            let rows = _transDetails.map((value) => ({
                sr_no: value.srNo,
                expense_category: value.expense_category,
                category_type: value.expense_type,
                amount: value.total
            }));
            dataList.rows = rows;
        }
    }

    return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  exportData = (event) =>{
    let _itemDetails = this.state.transactionArrayFilter;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {

        let newData = {
          'Expense Category': data.expense_category,
          'Category Type': data.expense_type,
          'Amount': numberFormat(data.total)
        }
         return newData;
      });

      let totalAmountRow = {
          'Expense Category': '',
          'Category Type': '',
          'Amount': ''
      };

      _itemDetails.push({});
      _itemDetails.push(totalAmountRow);
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Expense Category Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_expense_category_report_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Stock Summary</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                        Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                                            <i className="fa fa-plus-circle"></i> Add Sale
                                        </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
